import React from 'react';
import styles from './History.module.scss';
import PageTemplate from '../../templates/PageTemplate';
import Container from '../../templates/Container';
import Head from '../../elements/Head/Head';

import { ReactComponent as VenzelFive } from '../../../assets/svg/venzel_5_2color.svg';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Press = () => {
  const colorThemeRedux = useSelector((state) => state.theme.colorTheme);

  return (
    <>
      <PageTemplate>
        <Head />

        <Container>
          <section className={styles.history}>
            <h1 className={styles.title} style={colorThemeRedux ? { fontSize: 30, color: '#000' } : {}}>
              ПРЕСС-РЕЛИЗ ФЕСТИВАЛЯ МУЖСКИХ&nbsp;ХОРОВ 2025&nbsp;год
            </h1>
            {!colorThemeRedux && <div className={styles.separator} />}

            <div className={styles.frame + ' ' + (colorThemeRedux ? styles.lowVisibleVersion : '')}>
              <div className={styles.content}>
                <p>
                  С 07 июля по 31 октября 2025 года в рамках Года защитника Отечества в Красноярском крае,
                  географическом центре России, в четвёртый раз состоится знаменательное событие, направленное на
                  возрождение традиционной национальной культуры и патриотическое воспитание, – Фестиваль мужских хоров
                  (далее – Фестиваль).
                </p>
                <p>
                  Фестиваль проводится под патронатом Губернатора Красноярского края Михаила Михайловича Котюкова и по
                  благословению Митрополита Красноярского и Ачинского Никиты.
                </p>
                <p>Учредитель Фестиваля – министерство культуры Красноярского края.</p>
                <p>Организатором Фестиваля является структурное подразделение ГЦНТ – Культурно-исторический центр.</p>
                <p>
                  За дни Фестиваля пройдёт более 50 мероприятий, в том числе свыше 30 концертных программ будут
                  представлены в муниципальных образованиях Красноярского края, на которых выступят прославленные
                  мужские хоры из различных субъектов Российской Федерации (Республика Крым, Луганская Народная
                  Республика, Красноярский край, Московская область, гг. Москва, Севастополь, Ульяновск и др.), а также
                  зарубежья – Грузия, Китайская Народная Республика, Республика Беларусь, Республика Казахстан,
                  Республика Сербия.
                </p>
                <p>
                  Мероприятия Фестиваля мужских хоров в 2025 году включают: концерты мужских хоровых
                  коллективов-участников Фестиваля в Малом концертном зале им. И.В. Шпиллера и Большом концертном зале
                  Красноярской краевой филармонии, Гала-концерты в Большом концертном зале Красноярской краевой
                  филармонии, мастер-классы членов экспертного совета Фестиваля, творческие встречи и многое другое.
                </p>
                <p>
                  Фестиваль традиционно начнётся специальным проектом «Певческий берег» – 08 июля на набережной реки
                  Енисей у стен Успенского мужского монастыря города Красноярска будут исполнять духовные и
                  патриотические песни Академический ансамбль песни и пляски Российской Армии имени А.В. Александрова,
                  Праздничный хор Данилова монастыря (г. Москва), мужские хоры «Всехсвятский» (Республика Беларусь),
                  «Сихарули» (Грузия), Молодёжный хор дирижёров провинции Хэнань (Китайская Народная Республика), а
                  также Сибирский мужской хор (г. Красноярск).
                </p>
                <p>
                  Гала-концерты Фестиваля мужских хоров пройдут 09-10 октября в Большом концертом зале Красноярской
                  краевой филармонии. Начало концертов в 19:00. Билеты на концерты можно приобрести в кассах
                  Красноярской краевой филармонии и на официальном сайте www.krasfil.ru.
                </p>
                <p>
                  Билеты на концерты можно приобрести в кассах Красноярской краевой филармонии и на официальном сайте{' '}
                  <Link to="http://www.krasfil.ru" target="_blank" rel="noopener noreferrer">
                    www.krasfil.ru
                  </Link>
                  .
                </p>
                <br />
                <p>
                  <i>
                    Дополнительная информация для представителей СМИ по тел.{' '}
                    <Link to="tel:+79333327714">8-933-332-77-14</Link> или е-mail:{' '}
                    <Link to="mailto:m.t.o03@mail.ru">m.t.o03@mail.ru</Link> – Мария Олеговна Трушлякова, редактор
                    структурного подразделения ГЦНТ – Культурно-исторического центра.
                  </i>
                </p>
              </div>

              <VenzelFive />
              <VenzelFive />
              <VenzelFive />
              <VenzelFive />
            </div>

            {!colorThemeRedux && <div className={styles.separator + ' ' + styles.separator_down} />}
          </section>
        </Container>
      </PageTemplate>
    </>
  );
};

export default Press;
